import { combineReducers } from 'redux';
import authentication from './authentication/index';
import events from './events/index';
import application from './application';
import admin from './admin/index';
import contracts from './contracts/index';

import { routerReducer } from 'react-router-redux';

export default combineReducers({
    authentication,
    events,
    router: routerReducer,
    application,
    admin,
    contracts
});
